import type { GridRenderHeaderFilterProps } from "@mui/x-data-grid-premium";

import { DataGridDateRangeHeaderFilterImpl } from "src/components/DataGrid/DataGridDateRangeHeaderFilterImpl.tsx";

export const DataGridDateRangeHeaderFilter = (
  props: GridRenderHeaderFilterProps,
) => {
  // this wrapper exists only to enable hot reload
  return <DataGridDateRangeHeaderFilterImpl {...props} />;
};
